export default function between(num = 0, from = 0, to = 0) {
  return Number(num) > from && Number(num) < to
}
